import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation, validations } from "../../common/validation.common";
import { CustomerCategoryEnum } from "../../data/enums";

export namespace CustomerValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            phone: v.optional(baseVals.phone()),
            email: v.optional(baseVals.email()),
            username: baseVals.username(),
            password: baseVals.password(),
            address: baseVals.string(),
            location: v.optional(baseVals.coordinate()),
            category: v.optional(v.picklist(CustomerCategoryEnum.values)),
            area: v.optional(baseVals.string()),
            identityNumber: v.optional(baseVals.identityNumber()),
            notes: v.optional(baseVals.string()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            phone: v.exactOptional(baseVals.phone()),
            email: v.exactOptional(baseVals.email()),
            username: v.exactOptional(baseVals.username()),
            password: v.exactOptional(baseVals.password()),
            address: v.exactOptional(baseVals.string()),
            location: v.exactOptional(baseVals.coordinate()),
            category: v.exactOptional(v.picklist(CustomerCategoryEnum.values)),
            area: v.exactOptional(baseVals.string()),
            identityNumber: v.exactOptional(baseVals.identityNumber()),
            notes: v.exactOptional(baseVals.string()),
        }),
    );

    export const Remove = defineValidation(
        v.object({
            phone: validations.deletable,
        }),
    );

    export const Coords = defineValidation(
        v.object({
            lat: v.number(),
            lng: v.number(),
            radius: v.number(),
        }),
    );
}
